export default __webpack_public_path__ + "files/media/brand-new-white-logo.85bbae94.svg";